import ToolbarComponent from './Toolbar';
import MessagesListComponent from './MessagesList';
import MessagesPreviewComponent from './MessagePreview';

export const MessagesList = MessagesListComponent;
export const Toolbar = ToolbarComponent;
export const MessagePreview = MessagesPreviewComponent;
